import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { getEndDateStatus, formatTimeUntilExpiry } from './listingEndDateUtils';
import css from './ListingEndDateBadge.module.css';

/**
 * ListingEndDateBadge — shows expiry countdown on listing cards.
 *
 * Only shows when status is 'expiring' (within 3 days) or 'expired'.
 *
 * Usage (in ListingCard or ListingPage):
 *   {features.listingEndDate && listing.attributes.publicData.listingEndDate && (
 *     <ListingEndDateBadge endDate={listing.attributes.publicData.listingEndDate} />
 *   )}
 */
const ListingEndDateBadge = ({ endDate, className }) => {
  const status = getEndDateStatus(endDate);
  if (!status || status === 'active') return null;

  const timeText = formatTimeUntilExpiry(endDate);

  return (
    <div className={classNames(css.badge, css[status], className)}>
      <span className={css.icon}>{status === 'expired' ? '⏰' : '⚠️'}</span>
      <span>
        {status === 'expired'
          ? <FormattedMessage id="ListingEndDateBadge.expired" />
          : <FormattedMessage id="ListingEndDateBadge.expiring" values={{ time: timeText }} />}
      </span>
    </div>
  );
};

ListingEndDateBadge.defaultProps = { className: null };
ListingEndDateBadge.propTypes = { endDate: string.isRequired, className: string };

export default ListingEndDateBadge;
